export class DesignationDto {
    designationId?: number;
    designation: string;
    createdUser: string;
    isActive: boolean;
    updatedUser?: string;
    versionFlag?: number;
    constructor(designationId: number, designation: string, createdUser: string, isActive: boolean, updatedUser?: string, versionFlag?: number){
        this.designationId = designationId;
        this.designation = designation;
        this.createdUser = createdUser;
        this.isActive = isActive;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
    }
}